// src/pages/ClinicalDataCollector/components/output/ChronicConditionsSection.jsx

import React, { useMemo } from 'react';
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Divider,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import HealingIcon from '@mui/icons-material/Healing';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import PreventionIcon from '@mui/icons-material/Shield';
import DescriptionIcon from '@mui/icons-material/Description';
import { useSelector } from 'react-redux';

// 👇 nuevo: data simulada
import chronicConditionsData from '../data/chronicConditionsSectionData.json';

const ChronicConditionsSection = () => {
  const { PatientSelect } = useSelector((state) => state.patientMapSelect || {});

  const patients = chronicConditionsData?.patients || [];

  const selectedPatient = useMemo(() => {
    if (!patients.length) return null;

    // Si tenemos un paciente seleccionado, usamos un índice “estable”
    if (PatientSelect?.memberId) {
      const base =
        (PatientSelect.memberId.length || 1) +
        (PatientSelect.age || 0) * 7;
      const idx = Math.abs(base) % patients.length;
      return patients[idx];
    }

    // Si no hay PatientSelect, uno totalmente aleatorio
    const randomIdx = Math.floor(Math.random() * patients.length);
    return patients[randomIdx];
  }, [PatientSelect, patients]);

  if (!selectedPatient) {
    return null;
  }

  const { name, profile, chronicConditions } = selectedPatient;

  return (
    <Box>
      <Typography variant="h5" align="center" sx={{ mb: 1 }}>
        Chronic Conditions Section
      </Typography>
      {/* Subtítulo con el paciente simulado */}
      <Typography
        variant="subtitle2"
        align="center"
        sx={{ mb: 2, color: 'text.secondary' }}
      >
        {/* Simulated profile: {name} — {profile} */}
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={3}>
        {chronicConditions.map((cond, idx) => (
          <Grid item xs={12} md={4} key={idx}>
            <Card elevation={2} sx={{ borderRadius: 2, height: '100%' }}>
              <CardHeader
                avatar={<HealingIcon color="primary" />}
                title={`${cond.hcc} - ${cond.description}`}
                titleTypographyProps={{ variant: 'subtitle1' }}
              />
              <Divider />
              <CardContent>
                <Box sx={{ mb: 2 }}>
                  <Typography
                    variant="subtitle2"
                    sx={{ display: 'flex', alignItems: 'center', mb: 1 }}
                  >
                    <DescriptionIcon sx={{ mr: 1 }} /> Treatment Plan
                  </Typography>
                  <Typography variant="body2">
                    {cond.treatmentPlan}
                  </Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography
                    variant="subtitle2"
                    sx={{ display: 'flex', alignItems: 'center', mb: 1 }}
                  >
                    <FormatQuoteIcon sx={{ mr: 1 }} /> Suggested Verbiage
                  </Typography>
                  <Typography variant="body2" fontStyle="italic">
                    {cond.pcpVerbiage}
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{ display: 'flex', alignItems: 'center', mb: 1 }}
                  >
                    <PreventionIcon sx={{ mr: 1 }} /> Prevention Strategies
                  </Typography>
                  <List dense>
                    {cond.preventionStrategies.map((strat, i) => (
                      <ListItem key={i} disablePadding>
                        <ListItemIcon>
                          <PreventionIcon fontSize="small" color="secondary" />
                        </ListItemIcon>
                        <ListItemText primary={strat} />
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ChronicConditionsSection;
